let animate = {

    init: () =>{

        // animate__animated
        animate.name =  '.animate__animated';
        animate.elements = document.querySelectorAll(animate.name);
        animate.attemptActionIfNotEmpty(animate.ready);

        window.addEventListener('load', () => {
            animate.attemptActionIfNotEmpty(animate.loaded);
        });

        return animate;
    },

    attemptActionIfNotEmpty: function (action) {
        if (animate.elements.length > 0) {
            action();
        }
    },

    ready : () => {

        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.dataset.animate = "true";
                } else {

                }
            })
        };

        const options = {
            // the root object (window, viewport or any element)
            root: null,
            // margin around the root
            rootMargin: '0px',
            // even one pixel is visible
            threshold: 0.1
        };

        const animateObserver = new IntersectionObserver(callback, options);
        animate.elements.forEach((observerEL) => {
            animateObserver.observe(observerEL);
        });

    },

    loaded : () => {

    }

};

export default animate.init();
